import { FC, useCallback } from 'react'
import styles from './theme-switch.module.scss'
import { useDispatch } from 'react-redux'
import classNames from '@/utils/helpers/class-names.helper'
import { toggleTheme } from '@/redux/theme/slice'

type ThemeSwitchProps = {
  className?: string
}

const ThemeSwitch: FC<ThemeSwitchProps> = ({ className }) => {
  const dispatch = useDispatch()

  const handleThemeChange = useCallback(() => {
    dispatch(toggleTheme())
  }, [dispatch])

  return (
    <div className={classNames(styles.switch, className)}>
      <button
        className={classNames(styles.switcher, styles._theme)}
        onClick={handleThemeChange}
        type="button"
        aria-label="theme"
      >
        <span className={styles.switcher__track}></span>
        <span className={styles.switcher__thumb}></span>
      </button>
    </div>
  )
}

export default ThemeSwitch
